jQuery(window).load(function(){
  
  
  $('.flexslider').flexslider({
    animation: "slide",
    slideshow: true,
    animationDuration: 700,
    slideshowSpeed: 4000,
    animation: "fade",
    controlsContainer: ".flex-controls",
    controlNav: false,
    keyboardNav: true
  }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});
  
  
  $("select.loc_on_change").change(function(){
  	if($(this).attr("value") == "#") return false;
  	window.location = $(this).attr("value");
  });
    
  
  var IE6 = false /*@cc_on || @_jscript_version < 5.7 @*/;
  if(IE6){
    if($("#placeholder img").width() > 360){
      $("#placeholder img").css('width', '360px');
    } else {
      $("#placeholder img").css('width', $("#placeholder img").width()+'px'); // restrict to initial width of image
    }
  } else {
    $("#placeholder img").css('maxWidth', $("#placeholder img").width()+'px'); // restrict to initial width of image
  }

  var pw = $("#placeholder img").width() + 8;
  $("#placeholder img").parents('div.featured').css('maxWidth', pw+'px'); // force IE to play nice
  
});

jQuery(document).ready(function($){
  
  $(".tweet").tweet({ // twitter plugin
    username: "shopify",
    join_text: "auto",
    avatar_size: 32,
    count: 2,
    auto_join_text_default: "", 
    auto_join_text_ed: "",
    auto_join_text_ing: "",
    auto_join_text_reply: "",
    auto_join_text_url: "",
    loading_text: "Loading Tweets..."
  });
  	
  $("a.zoom").fancybox({
    padding:0,
    'titleShow': false,
    overlayColor: '#000000',
    overlayOpacity: 0.2
  });

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
  $('#product .thumbs a').click(function(){
    
    $('#zoom-image').attr('href', $(this).attr('href'));
    return false;
  });
  
  $('#product .add-to-cart').click(function(e){
    $('#add-item-to-cart').click();
  });
  
  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })
  
  $("li.dropdown").hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });
  
  $('a[href^="#"]').bind('click.smoothscroll',function (e) {
    e.preventDefault();
    
    var target = this.hash,
        $target = $(target);
    
    $('html, body').stop().animate({
        'scrollTop': $target.offset().top
    }, 500, 'swing', function () {
        window.location.hash = target;
    });
  });
  
  var tabs = $('ul.tabs > li > a');
  tabs.each(function(i) {
    jQuery(this).unbind('click.smoothscroll')
    .click(function(e) {
         var contentLocation = $(this).attr('href');
    	 if(contentLocation.charAt(0)=="#") {            
  		tabs.removeClass('active');
  		$(this).addClass('active');
  		$(contentLocation).show().addClass('active').siblings().hide().removeClass('active');
    	 }
      return false;
    });
  });
  
}); // end document ready
    

    
    
// Parameters: NONE
function add_charity()
    {
  	//alert("ENTERING CHARITY ADD");
    //Get the selected charity
  	var charity_id = $('input[type="radio"]:checked').val();
  
	//alert("CHARITY ID is "+charity_id);
  	//Check cart for existing charities - if there are any, remove them
  	$.ajax({
  		url: "/cart.js",
  		data: "",
  		dataType: 'json',
      	success: function(result) {
          	//alert("There are "+result.items.length+" items in the cart");
          	//alert(typeof result.items);
          	var count = 0;
            for (var i = 0, len = result.items.length; i < len; ++i) {
              var item = result.items[i];
              //alert("Checking for "+item.handle+" ("+item.vendor+")");
              if (item.vendor == "charity_donate")
              {
                if (result.items.length == 1){
              	alert ("Clearing Cart");
                 $.ajax({  
       			 	type: "POST",  
        			dataType:'json',
        			url: "/cart/clear.js",  //API call to save to cart
      				data: "",  
        			success: function(result) { 
            		//alert ("RESPONSE");
          				ret_status = "1";
        			},
					async:   false
    			});  
                }
                else
                {
              	//alert ("Removing variant:"+item.variant_id);
         		$.ajax({  
        			type: "POST",  
        			dataType:'json',
        			url: "/cart/change.js",  //API call to save to cart
      				data: {'quantity':0,'id':item.variant_id},  
        			success: function(result) { 
            			//alert ("RESPONSE");
          				return "1";
        			},
                    async:   false
    			}); 
                //alert ("Update status:"+update_status);
                }

              }
              else
              {
              //alert(item.vendor+" doesn't match");  
              }
              count = count + 1;
            }
  			//We've got the selected item - proceed to POST and redirect to all collections
          	if  (count == result.items.length)
            {
            // Here, we do an if to make sure it gets processed after the loop - not sure if this works yet
    		$.ajax({  
        		type: "POST",  
        		dataType:'json',
        		url: "/cart/add.js",  //API call to save to cart
      			data: {'quantity':1,'id':charity_id},  
        		success: function(result) { 
            		//alert ("DONE");
          			window.location="/collections/all";
        		},
                async:   false
    		});  
            }
      	},
      	async:   false
	});

    return false;
    }
    